module.exports = __webpack_public_path__ + "img/license.42586466.svg";